import { __extends } from "tslib";
import classNames from 'classnames';
import React from 'react';
import styles from './UploadInput.scss';
var UploadInput = /** @class */ (function (_super) {
    __extends(UploadInput, _super);
    function UploadInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputRef = React.createRef();
        _this.handleFile = function (event) {
            var files = event.target.files;
            if (files && files.length) {
                _this.props.onUpload(files);
            }
        };
        return _this;
    }
    UploadInput.prototype.click = function () {
        if (this.inputRef.current) {
            this.inputRef.current.click();
        }
    };
    UploadInput.prototype.render = function () {
        var _a = this.props, accept = _a.accept, disabled = _a.disabled, onClick = _a.onClick, multiple = _a.multiple, className = _a.className, children = _a.children;
        return (React.createElement("label", { "data-hook": "upload-button", "aria-disabled": disabled ? true : undefined, tabIndex: disabled ? undefined : 0, className: classNames(styles.label, className) },
            React.createElement("input", { ref: this.inputRef, "data-hook": "upload-button-input", type: "file", accept: accept.join(', '), multiple: multiple, disabled: disabled, onChange: this.handleFile, onClick: onClick }),
            children));
    };
    return UploadInput;
}(React.Component));
export default UploadInput;
//# sourceMappingURL=UploadInput.js.map